// extracted by mini-css-extract-plugin
module.exports = {"mark_base":"_2Jdai","with_shadow":"_3xiTp","rewardMark":"_15BUO","deliveryMark":"Btv40","tagInImportList":"_3rrss"};